<template>
  <div>
    <v-container fluid class="mt-16">
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              {{ tipoCliente }}

              <v-spacer></v-spacer>

              <v-text-field
                outlined
                dense
                class="mr-2"
                style="margin-top:-12px;"
                v-model="cadenaFiltroClientes"
                append-icon="mdi-magnify"
                @input="busquedaClientes(0)"
                label="Búsqueda"
                hide-details
                clearable
              ></v-text-field>
              <v-select
                dense
                outlined
                clearable
                class="mr-2"
                style="max-width:200px;margin-top:12px;"
                :items="sucursalesList"
                item-text="NOMBRE"
                item-value="ID"
                v-model="nombreSucursal"
                @input="busquedaClientes(0)"
                label="Sucursal"
              ></v-select>
              <v-select
                outlined
                dense
                style="margin-top:10px;max-width:200px;"
                :items="[5, 10, 15, 50]"
                label="Elementos por página"
                v-model="objetoBusquedaClientes.regPag"
                @input="busquedaClientes(0)"
              ></v-select>
              <v-btn
                @click="dialogNuevoCliente = true"
                style="float:right; margin-top:-17px;"
                color="primary"
                dark
                class="ml-2"
                >Nuevo {{ clienteRecortado }}</v-btn
              >
            </v-card-title>
            <v-alert v-if="mostrarErrorCarga" outlined type="error">
              Hubo un problema cargando la información, revise su conexión a internet e intente
              nuevamente.
            </v-alert>
            <v-data-table
              :loading="tableLoading"
              loading-text="Cargando... por favor espere."
              hide-default-footer
              :headers="headersRemitentes"
              :items="cualArregloDeItemsRegresar"
              :search="search"
              :items-per-page="objetoBusquedaClientes.regPag"
              :page.sync="objetoBusquedaClientes.regPag"
            >
              <template #item.actions="{ item }">
                <v-btn @click="editarCliente(item)" color="blue" class="mr-2" text rounded dark>
                  Editar
                  <v-icon small class="mr-2">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn @click="eliminarCliente(item.ID)" color="red" rounded dark text>
                  Borrar
                  <v-icon small class="mr-2">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="4"> </v-col>
        <v-col cols="4">
          <v-pagination
            @input="busquedaClientes(1)"
            v-model="objetoBusquedaClientes.pag"
            :length="cualCantidadDePaginasRegresar"
          ></v-pagination>
        </v-col>
        <v-col cols="4"></v-col>
      </v-row>
    </v-container>
    <ModalNuevoCliente
      @mostrarDialogClienteExitoso="mostrarDialogClienteExitosoX($event)"
      @cerrar-modal-cliente="cerrarModalCliente"
      v-if="dialogNuevoCliente"
      :show="dialogNuevoCliente"
      :tipoClientex="tipoCliente"
      :clientePasado="objetoClienteAEditar"
    />
    <ModalConfirmarEliminacion
      :show="dialogConfirmarEliminacion"
      v-if="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmarEliminacionClientes()"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
  </div>
</template>
<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import ModalNuevoCliente from "@/components/modales/ModalNuevoCliente.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";

export default {
  components: {
    ModalNuevoCliente,
    ModalConfirmarEliminacion,
    ModalErrorEnAccion
  },
  data: () => ({
    nombreSucursal:"",
    cadenaFiltroClientes: "",
    mostrarErrorCarga: false,
    tableLoading: false,
    objetoClienteAEditar: {},
    mensajeSnackbarExito: "",
    snackbarExito: false,
    idItemABorrar: 0,
    dialogConfirmarEliminacion: false,
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "",
    dialogNuevoCliente: false,
    search: "",
    tipoCliente: "",
    objetoBusquedaClientes: {
      pag: 1,
      regPag: 10,
      suc: 1
    },
    copiaRemitentes: [],
    copiaDestinatarios: [],
    headersRemitentes: [
      {
        text: "Alias",
        align: "center",
        sortable: true,
        value: "ALIAS"
      },
      {
        text: "Nombre",
        align: "center",
        sortable: true,
        value: "NOMBRE_COMPLETO"
      },
      {
        text: "Correo electrónico",
        align: "center",
        sortable: true,
        value: "EMAIL"
      },
      {
        text: "Dirección",
        align: "center",
        sortable: true,
        value: "DIRECCION"
      },
      {
        text: "Ciudad",
        align: "center",
        sortable: true,
        value: "MUNICIPIO"
      },
      {
        text: "Colonia",
        align: "center",
        sortable: true,
        value: "COLONIA"
      },
      {
        text: "Código postal",
        align: "center",
        sortable: true,
        value: "CODIGO_POSTAL"
      },
      {
        text: "Estado",
        align: "center",
        sortable: true,
        value: "ESTADO"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: true,
        value: "TELEFONO"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  async created() {
    this.tipoCliente = this.$route.name;
    this.tipoCliente =
      this.tipoCliente.charAt(0).toUpperCase() + this.tipoCliente.slice(1).toLowerCase();
    this.getSucursales();
    // await this.getRemitentes(this.objetoBusquedaClientes);

    this.busquedaClientes(0);
  },
  props: {
    clientType: String
  },
  methods: {
    ...mapActions("destinatarioRegistro", [
      "getDestinatarios",
      "deleteDestinatarios",
      "destroyDestinatarios"
    ]),
    ...mapActions("remitentesRegistro", ["getRemitentes", "deleteRemitentes", "destroyRemitentes"]),
    ...mapActions("sucursales", ["getSucursales"]),
    async mostrarDialogClienteExitosoX(mensaje) {
      this.snackbarExito=true;
      this.mensajeSnackbarExito=mensaje;
    },
    async obtenRemitentes() {
      this.tableLoading = true;
      const res = await this.getRemitentes(this.objetoBusquedaClientes);
      if (res[0]) {
        this.tableLoading = false;
        this.mostrarErrorCarga = false;
      } else if (res[1] === "errorcarga") {
        this.mostrarErrorCarga = true;
        this.tableLoading = false;
      }
    },

    async obtenDestinatarios() {
      this.tableLoading = true;
      const res = await this.getDestinatarios(this.objetoBusquedaClientes);
      if (res[0]) {
        this.tableLoading = false;
      } else if (res[1] === "errorcarga") {
        this.mostrarErrorCarga = true;
      }
    },

    async editarCliente(clienteAEditar) {
      this.dialogNuevoCliente = true;
      this.objetoClienteAEditar = clienteAEditar;
      // const indiceRemitenteEditar = this.remitentesList.findIndex(
      //   element => element.ID == this.objetoClienteAEditar.ID
      // );
    },
    cerrarModalCliente() {
      this.dialogNuevoCliente = false;
      this.busquedaClientes(1);
      this.objetoClienteAEditar = {};
    },
    eliminarCliente(data) {
      this.idItemABorrar = data;
      this.dialogConfirmarEliminacion = true;
    },
    async confirmarEliminacionClientes() {
      if (this.tipoCliente != "Remitentes") {
        const res = await this.deleteDestinatarios(this.idItemABorrar);
        if (res[0]) {
          this.dialogConfirmarEliminacion = false;
          this.busquedaClientes(0);
          this.snackbarExito = true;
          this.mensajeSnackbarExito = "Destinatario eliminado con éxito";
        } else {
          this.mensajeErrorModalErrorEnAccion = res[1];
          this.dialogErrorEnAccion = true;
          this.dialogConfirmarEliminacion = false;
        }
      } else {
        const res = await this.deleteRemitentes(this.idItemABorrar);
        if (res[0]) {
          this.dialogConfirmarEliminacion = false;
          this.busquedaClientes(0);
          this.snackbarExito = true;
          this.mensajeSnackbarExito = "Remitente eliminado con éxito";
        } else {
          this.mensajeErrorModalErrorEnAccion = res[1];
          this.dialogErrorEnAccion = true;
          this.dialogConfirmarEliminacion = false;
        }
      }
    },
    // metodo de busqueda principal
    busquedaClientes: _.debounce(async function(data) {
      this.objetoBusquedaClientes.suc=this.filtroBusquedaSucursal;
      this.objetoBusquedaClientes.filtroBusquedaFinal = this.filtroBusquedaClientes;
      if (data === 1) {
      } else {
        this.objetoBusquedaClientes.pag = 1;
      }
      if (this.tipoCliente == "Remitentes") {
        await this.obtenRemitentes();
        // if (res) {
        this.copiaRemitentes = JSON.parse(JSON.stringify(this.remitentesList));
        // this.copiaRemitentes = this.remitentesList;

        for (var i = 0; i < this.copiaRemitentes.length; i++) {
          if (this.copiaRemitentes[i].COLONIA) {
            const colonias = Array.from(JSON.parse(this.copiaRemitentes[i].COLONIA));
            const municipio = Array.from(JSON.parse(this.copiaRemitentes[i].MUNICIPIO));
            const direccion = Array.from(JSON.parse(this.copiaRemitentes[i].DIRECCION));

            const cp = Array.from(JSON.parse(this.copiaRemitentes[i].CODIGO_POSTAL));
            const estado = Array.from(JSON.parse(this.copiaRemitentes[i].ESTADO));
            this.copiaRemitentes[i].COLONIA = colonias.join(", ");
            this.copiaRemitentes[i].MUNICIPIO = municipio.join(", ");
            this.copiaRemitentes[i].DIRECCION = direccion.join(", ");
            this.copiaRemitentes[i].CODIGO_POSTAL = cp.join(", ");
            this.copiaRemitentes[i].ESTADO = estado.join(", ");
            // }
          }
        }
      } else {
        await this.obtenDestinatarios();

        this.copiaDestinatarios = JSON.parse(JSON.stringify(this.destinatariosList));
        // this.copiaDestinatarios = this.destinatariosList;

        for (var i = 0; i < this.copiaDestinatarios.length; i++) {
          if (this.copiaDestinatarios[i].COLONIA) {
            const colonias = Array.from(JSON.parse(this.copiaDestinatarios[i].COLONIA));
            const municipio = Array.from(JSON.parse(this.copiaDestinatarios[i].MUNICIPIO));
            const direccion = Array.from(JSON.parse(this.copiaDestinatarios[i].DIRECCION));
            const cp = Array.from(JSON.parse(this.copiaDestinatarios[i].CODIGO_POSTAL));
            const pais = Array.from(JSON.parse(this.copiaDestinatarios[i].PAIS));
            const estado = Array.from(JSON.parse(this.copiaDestinatarios[i].ESTADO));
            this.copiaDestinatarios[i].PAIS = pais.join(", ");
            this.copiaDestinatarios[i].COLONIA = colonias.join(", ");
            this.copiaDestinatarios[i].MUNICIPIO = municipio.join(", ");
            this.copiaDestinatarios[i].DIRECCION = direccion.join(", ");
            this.copiaDestinatarios[i].CODIGO_POSTAL = cp.join(", ");
            this.copiaDestinatarios[i].ESTADO = estado.join(", ");
          }
        }
      }
    }, 400)
  },
  beforeDestroy() {
    this.destroyRemitentes();
    this.destroyDestinatarios();
  },
  computed: {
    ...mapState("destinatarioRegistro", {
      destinatariosList: state => state.destinatarios,
      paginasDestinatarios: state => state.totalPaginas
    }),
    ...mapState("remitentesRegistro", {
      remitentesList: state => state.remitentes,
      paginasRemitentes: state => state.totalPaginas
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    cualArregloDeItemsRegresar() {
      if (this.tipoCliente == "Remitentes") {
        return this.copiaRemitentes;
      }
      return this.copiaDestinatarios;
    },
    cualCantidadDePaginasRegresar() {
      if (this.tipoCliente == "Remitentes") {
        return this.paginasRemitentes;
      }
      return this.paginasDestinatarios;
    },
    clienteRecortado() {
      return this.tipoCliente.substring(this.tipoCliente.length - 1, 0);
    },
    filtroBusquedaSucursal() {
      return this.nombreSucursal == "" || this.nombreSucursal == null
        ? ""
        : `&sucursal=${this.nombreSucursal}`;
    },
    filtroBusquedaClientes() {
      return this.cadenaFiltroClientes == "" || this.cadenaFiltroClientes == null
        ? ""
        : `&filtro=${this.cadenaFiltroClientes}`;
    }
  }
};
</script>
